<script>
import Label from "../form-components/Label.vue";
import Multiselect from "vue-multiselect";
import * as categoryService from "../../service/category.service";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: String,
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  components: {
    Label,
    Multiselect,
  },
  data() {
    return {
      options: [],
      value: this.item_value,
      d_check: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn]) ==
            this.item.displayOnValue
          : this.selectedItem[this.item.displayOn] == this.item.displayOnValue
        : false,
      d_check2: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn2] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn2]) ==
            this.item.displayOnValue2
          : this.selectedItem[this.item.displayOn2] == this.item.displayOnValue2
        : false,
      d_check3: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn3] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn3]) ==
            this.item.displayOnValue3
          : this.selectedItem[this.item.displayOn3] == this.item.displayOnValue3
        : false,
      disable_check:
        this.selectedItem &&
        this.item.disableOn &&
        this.selectedItem[this.item.disableOn]
          ? false
          : true,
    };
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
    display_none_check2: {
      get: function () {
        return this.d_check2;
      },
      set: function (newValue) {
        this.d_check2 = newValue;
      },
    },
    display_none_check3: {
      get: function () {
        return this.d_check3;
      },
      set: function (newValue) {
        this.d_check3 = newValue;
      },
    },
  },
  watch: {
    last_updated: {
      handler() {
        this.handledisplay();
      },
      deep: true,
    },
    item_value: {
      handler(val) {
        this.value = this.options.filter((x) => x.url == val)[0];
      },
      deep: true,
    },
    value(val) {
      if (val && val.id) {
        this.updateValue(this.item_key, val.url);
      } else {
        this.updateValue(this.item_key, "");
      }
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
  },
  methods: {
    handledisplay() {
      let val = this.last_updated;

      if (val && this.item.displayOn && val.key == this.item.displayOn) {
        if (typeof val.value == "object") {
          this.display_none_check =
            val.value.name == this.item.displayOnValue ? true : false;
        } else if (typeof val.value != "string") {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        } else {
          this.display_none_check =
            val.value == this.item.displayOnValue ? true : false;
        }
      }
      if (val && this.item.displayOn2 && val.key == this.item.displayOn2) {
        if (typeof val.value != "string") {
          this.display_none_check2 =
            JSON.stringify(val.value) == this.item.displayOnValue2
              ? true
              : false;
        } else {
          this.display_none_check2 =
            val.value == this.item.displayOnValue2 ? true : false;
        }
      }
      if (val && this.item.displayOn3 && val.key == this.item.displayOn3) {
        if (typeof val.value != "string") {
          this.display_none_check3 =
            JSON.stringify(val.value) == this.item.displayOnValue3
              ? true
              : false;
        } else {
          this.display_none_check3 =
            val.value == this.item.displayOnValue3 ? true : false;
        }
      }
      if (val && this.item.disableOn && val.key == this.item.disableOn) {
        let d_check = !val.value;
        // let d_check = val.value.find(x => JSON.stringify(x) == this.item.disableOnValue)
        this.disable_check = d_check ? true : false;
      }
    },
    async getOptions() {
      let filter = {
        where: {
          name: "Documents",
          cmsId: this.$route.params.cmsId,
        },
        include: [
          {
            relation: "pages",
          },
        ],
      };

      filter = encodeURIComponent(JSON.stringify(filter));

      let data = await categoryService.getWithFilter(filter);
      let pages = data.length ? data[0].pages : [];
      let validFileFormats = [
        "image/apng",
        "image/avif",
        "image/gif",
        "image/jpeg",
        "image/png",
        "image/svg+xml",
        "image/webp",
      ];
      this.options = pages.filter((x) =>
        validFileFormats.includes(x.additionalProp1.fileFormat)
      );
      this.value = this.options.filter((x) => x.url == this.item_value)[0];
    },
  },
  mounted() {
    this.item.display = false;
    this.getOptions();
  },
};
</script>
<template>
  <div
    :class="{
      'd-none':
        (item.displayOn && !display_none_check) ||
        (item.displayOn2 && !display_none_check2) ||
        (item.displayOn3 && !display_none_check3),
    }"
  >
    <Label :item="item" />
    <multiselect
      track-by="title"
      label="title"
      v-model="value"
      :options="options"
      :searchable="options.length > 5 ? true : false"
      :close-on-select="true"
      :show-labels="false"
      :placeholder="item.placeholder"
      :allow-empty="true"
      :preselectFirst="true"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <span class="option__desc">
          <span class="option__title">{{ option.title }}</span>
        </span>
      </template>
      <template slot="option" slot-scope="{ option }">
        <img
          class="option__image"
          :src="option.url"
          alt="Image"
          style="height: 5em"
        />
        <div class="option__desc pt-3">
          <span class="option__title">{{ option.title }}</span>
        </div>
      </template>
    </multiselect>
    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>
<style>
span.multiselect__option--highlight {
  background: #b6bcc5 !important;
}
</style>
